import { ReactElement, ReactNode } from 'react';
import { makeStyles } from 'tss-react/mui-compat';

const useStyles = makeStyles()((theme) => ({
  root: {
    margin: theme.spacing(4),
    maxWidth: theme.breakpoints.values.lg,
    '& p': {
      lineHeight: '1.5',
      marginBottom: '1rem',
    },
    '& ol, & ul': {
      ...theme.typography.body1,
      margin: '0 0 1rem 0',
      '& ol, & ul': {
        margin: '0px',
      },
    },
    '& h2': {
      marginBottom: '1rem',
    },
    '& h3': {
      color: theme.palette.primary.main,
      marginBottom: '0.6rem',
    },
    '& h4': {
      color: theme.palette.primary.main,
      fontSize: '1.25rem',
      marginBottom: '0.3rem',
    },
    '& table': {
      width: 'auto',
      margin: theme.spacing(1, 0),
    },
    '& td, & th': {
      padding: theme.spacing(0, 2),
      borderTop: `1px solid ${theme.palette.grey[100]}`,
      borderLeft: `1px solid ${theme.palette.grey[100]}`,
    },
    '& td:last-of-type, & th:last-of-type': {
      borderRight: `1px solid ${theme.palette.grey[100]}`,
    },
    '& tr:last-of-type td': {
      borderBottom: `1px solid ${theme.palette.grey[100]}`,
    },
    '& th': {
      fontWeight: theme.typography.fontWeightBold,
    },
  },
}));

export interface TextProps {
  children?: ReactNode;
}

export function Text({ children }: Readonly<TextProps>): ReactElement<TextProps> {
  const { classes } = useStyles();

  return <section className={classes.root}>{children}</section>;
}
